export const findElementByTagAndText = ({ withIn, tag, text }) => {
    if (!withIn) return;
    const elementsNodeList = withIn.querySelectorAll(tag);
    const elementMatchesText = element => element.textContent.toLowerCase().includes(text.toLowerCase());

    return Array.from(elementsNodeList).find(elementMatchesText);
};
